export const SELECTED_CLASS_REQUEST = 'SELECTED_CLASS_REQUEST';
export const SELECTED_CLASS_SUCCESS = 'SELECTED_CLASS_SUCCESS';
export const SELECTED_CLASS_FAILURE = 'SELECTED_CLASS_FAILURE';

export const SELECTED_VERSION_REQUEST = 'SELECTED_VERSION_REQUEST';
export const SELECTED_VERSION_SUCCESS = 'SELECTED_VERSION_SUCCESS';
export const SELECTED_VERSION_FAILURE = 'SELECTED_VERSION_FAILURE';

export const SUBJECTS_REQUEST = 'SUBJECTS_REQUEST';
export const SUBJECTS_SUCCESS = 'SUBJECTS_SUCCESS';
export const SUBJECTS_FAILURE = 'SUBJECTS_FAILURE';

export const SSB_SECTION_REQUEST = 'SSB_SECTION_REQUEST';
export const SSB_SECTION_SUCCESS = 'SSB_SECTION_SUCCESS';
export const SSB_SECTION_FAILURE = 'SSB_SECTION_FAILURE';

export const SEARCH_REQUEST = 'SEARCH_REQUEST';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_FAILURE = 'SEARCH_FAILURE';

export const SEARCH_CODE = 'SEARCH_CODE';

export const CHANGES_REQUEST = 'CHANGES_REQUEST';
export const CHANGES_SUCCESS = 'CHANGES_SUCCESS';
export const CHANGES_FAILURE = 'CHANGES_FAILURE';

export const CORRESPONDENCE_REQUEST = 'CORRESPONDENCE_REQUEST';
export const CORRESPONDENCE_SUCCESS = 'CORRESPONDENCE_SUCCESS';
export const CORRESPONDENCE_FAILURE = 'CORRESPONDENCE_FAILURE';

export const VARIANT_REQUEST = 'VARIANT_REQUEST';
export const VARIANT_SUCCESS = 'VARIANT_SUCCESS';
export const VARIANT_FAILURE = 'VARIANT_FAILURE';

export const SUBSCRIPTION_REQUEST = 'SUBSCRIPTION_REQUEST';
export const SUBSCRIPTION_SUCCESS = 'SUBSCRIPTION_SUCCESS';
export const SUBSCRIPTION_FAILURE = 'SUBSCRIPTION_FAILURE';

export const TOGGLE_ALL = 'TOGGLE_ALL';
export const TOGGLE_SUBJECT = 'TOGGLE_SUBJECT';
export const TOGGLE_CODE = 'TOGGLE_CODE';
export const TOGGLE_VARIANT = 'TOGGLE_VARIANT';
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';
export const TOGGLE_MODAL = 'TOGGLE_MODAL';
